import { Observable, map } from "rxjs";
import { ParkerFunctionExecutor } from "./parker-function-executor.class";
import { EndSubscriptionFormGroup } from "../parker-function-end-subscription-form/parker-function-end-subscription-form.type";
import { ParkerClient, ParkerDTO, ParkingSubscriptionClient } from "src/app/base/models/models.swagger.generated";
import { DateTime } from "luxon";
import { TranslateService } from "@ngx-translate/core";
import { ParkerInfo } from "../parker-execution-status";
import { UpdateParkerUtil } from "./update-parker.util";

export class EndSubscriptionExecutor extends ParkerFunctionExecutor {
  private validTo: DateTime;

  constructor(numTotalRecordsToWorkOn: number,
              private subscriptionEndingForm: EndSubscriptionFormGroup,
              private parkingSubscriptionClient: ParkingSubscriptionClient,
              private parkerClient: ParkerClient,
              private translateService: TranslateService) {
    super(numTotalRecordsToWorkOn);
  }

  protected prepare(): Observable<void> {
    return this.parkingSubscriptionClient.getParkingSubscription(this.subscriptionEndingForm.controls.subscriptionId.value).pipe(map(sub => {
      this.validTo = DateTime.fromJSDate(this.subscriptionEndingForm.controls.validTo.value ?? new Date());
      if (this.validTo < DateTime.now()) {
        this.validTo = DateTime.now();
      }
    }));
  }

  protected executeFunctionOnParker(parker: ParkerDTO): Observable<number> {
    const updateParkerDTO = UpdateParkerUtil.createUpdateParkerDTO(parker);
    return this.parkerClient.updateParker(updateParkerDTO).pipe(map(parker => parker.id));
  }

  protected preFilterParkersAndUpdateExecutionStatus(parkers: ParkerDTO[]): ParkerDTO[] {
    const parkersToUpdate: ParkerDTO[] = [];
    const subscriptionId = this.subscriptionEndingForm.controls.subscriptionId.value;
    parkers?.forEach(parker => {
      if (parker.parkerSubscriptionAssignments?.some(a => a.subscription.id === subscriptionId)) {
        const subscriptionAssignmentsToKeep = [];
        parker.parkerSubscriptionAssignments.forEach(a => {
          if (a.subscription.id === subscriptionId) {
            if (a.validTo != null && a.validTo < this.validTo) {
              // subscription ends before the form's valid to date -> no change needed
              subscriptionAssignmentsToKeep.push(a);
              return;
            }
            a.validTo = this.validTo;
            if (a.validFrom <= this.validTo) {
              // subscriptoin assignments starting before the form's valid to date are kept others deleted
              subscriptionAssignmentsToKeep.push(a);
            }
          } else {
            subscriptionAssignmentsToKeep.push(a);
          }
        });
        parker.parkerSubscriptionAssignments = subscriptionAssignmentsToKeep;
        parkersToUpdate.push(parker);
      }
      else {
        this.executionStatus.push({
          status: 'warning',
          message: this.translateService.instant('i18n.domain.parker-administration.overview.function-dialog.function-status-dialog.message-parker-subscription-not-assigned'),
          parkerInfo: new ParkerInfo(parker)
        });
      }
    });
    return parkersToUpdate;
  }
}
